import { IError, Maybe } from 'types/graphqlTypes'
import { useUpdateShipperRateCarrierSalesRepMutation } from '../components/AwardedLaneModal/Sidebar/CarrierSalesRepSelector/graphql/UpdateShipperRateCarrierSalesRep'

export interface IAwardedLaneMutationResult {
  awardedLaneId: string | undefined
  errors: IError[] | undefined
}

interface IUseAwardedLaneMutationsState {
  reassignCarrierSalesRep: (salesRepId: Maybe<string>) => Promise<IAwardedLaneMutationResult | null>
  loading: boolean
}

interface IUseAwardedLaneMutationsProps {
  awardedLaneId?: string
}

const useAwardedLaneMutations = ({
  awardedLaneId,
}: IUseAwardedLaneMutationsProps): IUseAwardedLaneMutationsState => {
  const [reassignShipperRate, { loading }] = useUpdateShipperRateCarrierSalesRepMutation()

  const reassignCarrierSalesRep = async (
    carrierSalesRepId: Maybe<string>
  ): Promise<IAwardedLaneMutationResult | null> => {
    if (!awardedLaneId) {
      return null
    }

    const { data } = await reassignShipperRate({
      variables: {
        id: awardedLaneId,
        carrierSalesRepId,
      },
    })

    const { updateShipperRate } = data || {}
    const { errors, shipperRate } = updateShipperRate || {}
    const { id } = shipperRate || {}
    return {
      awardedLaneId: id,
      errors,
    }
  }

  return {
    reassignCarrierSalesRep,
    loading,
  }
}

export default useAwardedLaneMutations
